import { GroupEntity } from '../apis/group/group-entity';
import { ScheduleEntity } from '../apis/schedule/schedule-entity';

export class ScheduleDisplayNameService {
    public static getDisplayName(schedule: ScheduleEntity, groups: GroupEntity[], selectedGroupId?: string): string {
        const relevantIds = selectedGroupId
            ? (schedule.groupIds ?? []).filter(id => id === selectedGroupId)
            : (schedule.groupIds ?? []);
        const groupPart = relevantIds
            .map(id => groups.find(group => group.id === id)?.name ?? '')
            .filter(Boolean)
            .join(' / ');
        const namePart = schedule.name?.trim() ?? '';

        if (groupPart && namePart) { return `${groupPart} - ${namePart}`; }
        return groupPart || namePart;
    }
}
